const KEY = "OSSTOKEN";

// LIST
export const TOKEN_REQUEST = `TOKEN_${KEY}_REQUEST`;
export const TOKEN_SUCCESS = `TOKEN_${KEY}_SUCCESS`;
export const TOKEN_ERROR = `TOKEN_${KEY}_ERROR`;
